module.exports = __webpack_public_path__ + "img/ic-payment-r-card.8704c2ca.svg";